<div class="page-layout blank fullwidth p-12" style="height: 1px; overflow-y: scroll;    top: 1px;z-index: 1000;background: linear-gradient(to right, #F7FBFF, #FFFFFF) !important;">

  <div style="display: flex;justify-content: space-between;align-items: center;" *ngIf="isMobile">
    
    <h2 class="my-order">📋 My Orders</h2>
               <div class="toggle" >
            <!-- <img src="../../../../assets/images/order-details/magic.jpg"> -->
            <div class="magic-switch">
              <div>✨ Magic Quote</div>
              <label class="switch">
                <input type="checkbox" [checked]="isOn" (change)="toggle($event)">
                <span class="slider">
                </span>
              </label>
            </div>
        </div>
  </div>
<div class="order-list">
  <div class="my-orders">
    <h2 class="title" *ngIf="!isMobile">📋 My Orders</h2>
    <div class="search-magic">
     <div [ngClass]="isMobile ? 'searchMobile' : 'search'">
          
          <input 
          type="text" 
          [(ngModel)]="searchTerm" 
          (keydown.enter)="filterOrders()" 
          (input)="filterOrders()" 
          (click)="filterOrders()"
        />
        <span 
          class="close-button" 
          *ngIf="hideScrollText" 
          (click)="clearSearch()" 
          class="clear-btn"
        >✖</span>
        <div 
          class="scroll-text-container-request-list"
        >
          <div class="SearchBarIcon">
            <i class="material-icons-search">search</i>
          </div>
          <div 
            class="scroll-text" 
            [class.hidden]="hideScrollText"
          >
            <div id="animation-1" class="SearchBarAnimationText">Search By "Order ID"</div>
            <div id="animation-2" class="SearchBarAnimationText">Search By "Request ID"</div>
            <div id="animation-3" class="SearchBarAnimationText">Search By "Registration Number"</div>
            <div id="animation-4" class="SearchBarAnimationText">Search By "Car Make"</div>
            <div id="animation-5" class="SearchBarAnimationText">Search By "Car Model"</div>
            <div id="animation-6" class="SearchBarAnimationText">Search By "Fuel Type"</div>
            <div id="animation-7" class="SearchBarAnimationText">Search By "Invoice Number"</div>
            <div id="animation-8" class="SearchBarAnimationText">Search By "Part Name"</div>

          </div>

            </div>
            </div>
               <div class="toggle" *ngIf="!isMobile">
            <!-- <img src="../../../../assets/images/order-details/magic.jpg"> -->
            <div class="magic-switch">
              <div>✨ Magic Quote</div>
              <label class="switch">
                <input type="checkbox" [checked]="isOn" (change)="toggle($event)">
                <span class="slider">
                </span>
              </label>
            </div>
        </div>
        
          <!-- <button *ngIf="!isMobile" class="searchbutton" (click)="filterOrders()">🔍 Search Orders</button>
          <button *ngIf="isMobile" class="searchbutton" (click)="filterOrders()">🔍</button> -->
          <span  (click)="sidecontainer()" *ngIf="isMobile" class="filterslist">
            <mat-icon>filter_list</mat-icon>
            Filters
          </span>
        </div>


  </div>

    <!-- <mat-progress-bar class="mt-8" *ngIf="loading" mode="indeterminate"></mat-progress-bar> -->
    <div [ngClass]="isMobile? 'containerMobile' : 'container'">
      <div class="sidecontainer" *ngIf="!isMobile" >
        <div class="sidebar">
          <div class="filter-clear-btn">
            <h3 >⚙️ Filters</h3> 
            <div *ngIf="hasAppliedFilters()" (click)="clearFilters()" class="clear-filters-btn">Clear Filters</div>
          </div>
          <!-- Conditionally show the Clear Filters button -->
          <div class="clear">
            <div *ngIf="hasAppliedFilters()" class="applied-filters">
                <!-- <h4>Applied Filters</h4> -->
                <div *ngFor="let appliedFilter of getAppliedFilters()" class="apply">
                    <span>{{ appliedFilter.option.label }}</span>
                    <mat-icon (click)="removeFilter(appliedFilter.orderTime, appliedFilter.option)" class="apply1" >cancel</mat-icon>
                </div>                                
            </div>    
        </div>
 
          <!-- Order-status -->
          <div class="filter-section">
            <h4 >Order Status</h4>
            <div *ngFor="let status of filters.orderStatus" class="filter-option">
              <label>
                <span>{{ status.label }}</span>
                <span class="radio-container">
                  <input type="radio" name="orderStatus" [(ngModel)]="selectedOrderStatus" [value]="status.value" (change)="toggleSelection('orderStatus', status)" class="filter-radio">
                </span>
              </label>
            </div>
          </div>
          
          <!-- Order-Time -->
          <div class="filter-section">
            <h4 >Order Time</h4>
            <div *ngFor="let time of filters.orderTime">
              <div *ngIf="time.children; else singleRadio" class="filter-option">
                <h5>{{ time.label }}</h5>
                <div *ngFor="let child of time.children" class="filter-option">
                  <label>
                    <span>{{ child.label }}</span>
                    <span class="radio-container">
                      <input type="radio" name="orderTime" [(ngModel)]="selectedOrderTime" [value]="child.value" (change)="toggleSelection('orderTime', child)" class="filter-radio">
                    </span>
                  </label>
                </div>
              </div>
              <ng-template #singleRadio>
                <label class="filter-option">
                  <span>{{ time.label }}</span>
                  <span class="radio-container">
                    <input type="radio" name="orderTime" [(ngModel)]="selectedOrderTime" [value]="time.value" (change)="toggleSelection('orderTime', time)" class="filter-radio">
                  </span>
                </label>
              </ng-template>
            </div>
          </div>
        </div>
      </div>
      <div [ngClass]="isMobile ? 'main-contentMobile' : 'main-content'">




<!-- Conditionally show the sidecontainer based on the value of isSidebarOpen -->
<div class="overlay" [class.visible]="isSidebarOpen" (click)="sidecontainer()"></div>
<div *ngIf="isSidebarOpen" class="sidecontainerMobile">
  <div class="sidebarMobile">
    <div class="filter-with-close">
      <div class="filter-close">
        <h3><i (click)="sidecontainer()" class="material-icons" style="color: black;font-weight: bold;margin-right: 21px;top: 5px;position: relative; cursor: pointer;">arrow_back</i>Filters</h3>
      </div>
      <div class="close-icon">
        <mat-icon (click)="sidecontainer()">close</mat-icon>
      </div>
      </div>

    <hr />

    <!-- Conditionally show the Clear Filters button -->
    <div class="clear">
      <div *ngIf="hasAppliedFilters()" class="applied-filters">
        <h4>Applied Filters</h4>
        <div *ngFor="let appliedFilter of getAppliedFilters()" class="apply">
          <span>{{ appliedFilter.option.label }}</span>
          <mat-icon (click)="removeFilter(appliedFilter.orderTime, appliedFilter.option)" class="apply1">cancel</mat-icon>
        </div>
      </div>

      <div *ngIf="hasAppliedFilters()" (click)="clearFilters()" class="clear-filters-btn">
        Clear Filters
      </div>
    </div>

    <!-- Filter Sections -->
    <div class="filter-section">
      <h4>ORDER STATUS</h4>
      <div *ngFor="let status of filters.orderStatus" class="filter-option">
        <label>
          <span>{{ status.label }}</span>
          <span class="radio-container">
            <input type="radio" name="orderStatus" [(ngModel)]="selectedOrderStatus" [value]="status.value" (change)="toggleSelection('orderStatus', status)" class="filter-radio">
          </span>
        </label>
      </div>
    </div>
    <hr />

    <div class="filter-section">
      <h4>ORDER TIME</h4>
      <div *ngFor="let time of filters.orderTime">
        <div *ngIf="time.children; else singleRadio" class="filter-option">
          <h5>{{ time.label }}</h5>
          <div *ngFor="let child of time.children" class="filter-option">
            <label>
              <span>{{ child.label }}</span>
              <span class="radio-container">
                <input type="radio" name="orderTime" [(ngModel)]="selectedOrderTime" [value]="child.value" (change)="toggleSelection('orderTime', child)" class="filter-radio">
              </span>
            </label>
          </div>
        </div>
        <ng-template #singleRadio>
          <label class="filter-option">
            <span>{{ time.label }}</span>
            <span class="radio-container">
              <input type="radio" name="orderTime" [(ngModel)]="selectedOrderTime" [value]="time.value" (change)="toggleSelection('orderTime', time)" class="filter-radio">
            </span>
          </label>
        </ng-template>
      </div>
    </div>
<div class="applyFilter">
    <button (click)="sidecontainer()" class="applyFilterText">Apply Filter</button>
  </div>
  </div>
</div>
        
  
        <!-- Order Headers -->
        <!-- <div *ngIf="loading">Loading...</div> -->
        <div class=no-img *ngIf="!loading && filteredOrderList.length === 0">
          <img [src]="emptyList" alt="No data available" />
          <h1 class="no-request-text" >No Order Found</h1>
          <div class="eidt-text">Edit filter or go back to my order page</div>
          <button class="go-back-btn" (click)="clearFilters()" >Go to My Orders</button>
        </div>
        <div *ngIf="!loading && filteredOrderList.length > 0">
          <div *ngFor="let list of filteredOrderList">
            <div class="header" >  
              <div class="header-row">
                <!-- <div [ngClass]="isMobile ? 'order-iconMobile' : 'order-icon'">
                  <i class="material-icons">check_box</i>
                </div> -->
                <div class="order-info">
                  <!-- <div class="order-status">
                    <h1 *ngIf="list.titleName && list.titleName !== '0 minutes'" >
                      Order delivered in {{ list.titleName }}</h1>


                      <div>{{list.titleName}}</div>
                      <h1 *ngIf="list.titleName && list.titleName === '0 minutes'" >
                        Your order is in progress</h1>-->
                        
                    
                    <!-- <div 
                      class="delivery-statusMobile" 
                      *ngIf="isMobile"
                      [ngClass]="{
                          'delivered-status': list.orderCurrentStatus === 'Delivered',
                          'confirmed-status': list.orderCurrentStatus === 'Confirmed',
                          'packed-status': list.orderCurrentStatus === 'Packed',
                          'on-the-way':list.orderCurrentStatus==='On The Way'}">
                        {{list.orderCurrentStatus}}
                    </div> -->
                  <!-- </div> -->
                  <div class="request-ids" >
                  <div>
                    <div class="orrder-number-and-status">

                      <div class="order-num-and-status">
                      <svg style ="  width: 36px;    height: 36px;opacity: 1;  top: 196px; left: 333px; border-radius: 12px;    background: linear-gradient(90deg, #E8F2FF 100%, #D7F5FC 0%); padding: 7px;    box-shadow: 0px 1px 0px 0px #FFFFFF;" width="17" height="21" viewBox="0 0 17 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M5.47461 3.59735H3.47461C2.94418 3.59735 2.43547 3.80806 2.0604 4.18314C1.68532 4.55821 1.47461 5.06692 1.47461 5.59735V17.5974C1.47461 18.1278 1.68532 18.6365 2.0604 19.0116C2.43547 19.3866 2.94418 19.5974 3.47461 19.5974H13.4746C14.005 19.5974 14.5137 19.3866 14.8888 19.0116C15.2639 18.6365 15.4746 18.1278 15.4746 17.5974V5.59735C15.4746 5.06692 15.2639 4.55821 14.8888 4.18314C14.5137 3.80806 14.005 3.59735 13.4746 3.59735H11.4746M5.47461 3.59735C5.47461 4.12778 5.68532 4.63649 6.0604 5.01156C6.43547 5.38664 6.94418 5.59735 7.47461 5.59735H9.47461C10.005 5.59735 10.5137 5.38664 10.8888 5.01156C11.2639 4.63649 11.4746 4.12778 11.4746 3.59735M5.47461 3.59735C5.47461 3.06692 5.68532 2.55821 6.0604 2.18314C6.43547 1.80806 6.94418 1.59735 7.47461 1.59735H9.47461C10.005 1.59735 10.5137 1.80806 10.8888 2.18314C11.2639 2.55821 11.4746 3.06692 11.4746 3.59735M8.47461 10.5974H11.4746M8.47461 14.5974H11.4746M5.47461 10.5974H5.48461M5.47461 14.5974H5.48461" stroke="#1B5CA0" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                    <div>
                        <div class="order-id" *ngIf="list?.orderNumber">Order No# {{ list.orderNumber }}</div>
                        <div class="order-id" *ngIf="!list?.orderId">Order No# {{ list.orderId }}</div>
                        
                    <div class="rqstid-ttlamnt">
                      <div class="req-id-and-amount" style="display: flex;">
                        <div class="request-id" *ngIf="list.requestId !== 0">Request ID# {{list.requestId}}</div>
                        <!-- <div class="order-amount">Total Amount - ₹{{list.grandTotal}} </div> -->
                        <div _ngcontent-jni-c396="" *ngIf="list.requestId !== 0"class="toolbar-separator"></div>
                        <div class="order-amount">
                        ₹{{ list.grandTotal + (list.shippingCharges > 0 ? list.shippingCharges : 0) | number:'1.2-2' }}
                        </div>
                      </div>
                      <div class="invoice-number" *ngIf="list.orderInvoice?.length > 0">
                        Invoice No# {{ list.orderInvoice[0]?.invoiceNumber }}
                      </div>

                    </div>
                    </div>
                      </div>
                       
                      <!-- Show status only if NOT Delivered -->
                       <div class="magic-flow">
                      <div  *ngIf="list.packageDetails.length <= 0">
                      <div class="status requested"  *ngIf="list.orderCurrentStatus === 'Packed'">📦 Packed</div>
                      <div class="status quote-received"  *ngIf="list.orderCurrentStatus === 'On The Way'">🚚 On The Way</div>
                      <div class="status quote-approved"  *ngIf="list.orderCurrentStatus === 'Confirmed'">✅ Confirmed</div>
                      <div class="status order-created"  *ngIf="list.orderCurrentStatus === 'Delivered'">📍 Delivered</div>
                      <div class="status ordered-created"  *ngIf="list.orderCurrentStatus === 'created'">🆕 Created</div>
                    </div>
                       <div  *ngIf="list.packageDetails.length == 1 && list.notPackedItems.length <= 0">
                        <div *ngFor="let delivery of list.packageDetails; let i = index">
                        <div class="status requested"  *ngIf="delivery.shipmentStatus === 'packed'">📦 Packed</div>
                      <div class="status quote-received"  *ngIf="delivery.shipmentStatus === 'On The Way'">🚚 On The Way</div>
                      <div class="status quote-approved"  *ngIf="delivery.shipmentStatus === 'confirmed'">✅ Confirmed</div>
                      <div class="status order-created"  *ngIf="delivery.shipmentStatus === 'delivered'">📍 Delivered</div>
                      <div class="status ordered-created"  *ngIf="delivery.shipmentStatus === 'created'">🆕 Created</div>
                       </div>
                      </div>
                      <img class="magic" src="../../../../assets/images/order-details/magic.jpg" *ngIf="list.magicQuote==1">
                      </div>
                    </div>
                    <div class="order-status1" *ngFor="let delivery of list.packageDetails; let i = index">
                    <div  *ngIf=" delivery.shipmentStatus === 'delivered' && list.packageDetails.length == 1 && list.notPackedItems.length <= 0">
                          <div class="time-badge">
                            <div class="delived-in-time">⏰ {{ delivery.time }}</div>
                          </div>
                        </div>
                        </div>
                    <div *ngIf="list.packageDetails.length <= 0">
                       <div class="order-status1" *ngIf=" list.orderCurrentStatus === 'Delivered' && list.packageDetails.length <= 1 ">
                          <div class="time-badge">
                            <div class="delived-in-time">⏰ {{ list.titleName }}</div>
                          </div>
                        </div>
                        </div>
                    
                  </div>
                </div>
              </div>
              </div>
                  <!-- If MAKE is present -->
            <div *ngIf="list?.make" style="padding: 0px 0 10px 0px;border-bottom: 1px solid #E6EEFC;" >
              <div class="logo-container">
                  <img style="width: 4%;margin-right: 7px;"
                    [src]="'https://cube.getpitstop.com/assets/img/' + list.make.toLowerCase().replace(' ', '') + '.png'" 
                    alt="Make Image"
                  >
                <p style="font-weight:bold;margin: 0;">{{ list.model }}, {{ list.fuelType }}</p>
              </div>


              <!-- <div class="model-sec" style="width:80%; line-height: 2.4px;" *ngIf="list?.model">
                <p style="font-weight:bold">{{ list.model }}, {{ list.fuelType }}</p>
                
              </div> -->
              <p class="variant-year">{{ list.variant }} [{{ list.mfgYear }}] · {{ list.registrationNumber }}</p>

              <div class="model-sec" style="width:80%; line-height: 2.4px;" *ngIf="!list?.model">
                <img src="../../../../assets/images/ac_car_icon.svg" style="width: 24px; height: 24px; margin-right: 9px;" alt="car-icon">
                <span *ngIf="list?.registrationNumber">{{ list.registrationNumber }}</span>
              </div>
            </div>

              <!-- If MAKE is NOT present -->
              <div *ngIf="!list?.make && list?.registrationNumber" style="margin-top: 11px; margin-bottom: 11px; align-items: center; display: flex;" >
                <div class="logo-container-new" >
                  <div class="logo-new">
                  <img src="../../../../assets/images/ac_car_icon.svg" style="width: 24px; height: 24px;" alt="dummy-car">
                  </div>
                </div>
                 <span *ngIf="list?.registrationNumber" style="margin-left: 10px;">{{ list.registrationNumber }}</span>
              </div>
              <div  *ngIf ="list.packageDetails.length <= 1 && list.notPackedItems.length <= 0" class="delivery-content">
                <div  class="request-ids">
                  <div class="header-row1">
                    <div class="order-item">
                      <div class="items-rqstd-cls">Items Ordered</div>
                      <span *ngFor="let item of list.orderItems; let idx = index" class="item-name">
                        <span *ngIf="idx != 0">,</span> {{ item.partName }}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div  *ngIf ="list.packageDetails.length <= 0 && list.notPackedItems.length >= 0" class="delivery-content">
                <div  class="request-ids">
                  <div class="header-row1">
                    <div class="order-item">
                      <div class="items-rqstd-cls">Items Ordered</div>
                      <span *ngFor="let item of list.orderItems; let idx = index" class="item-name">
                        <span *ngIf="idx != 0">,</span> {{ item.partName }}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div *ngIf="list.packageDetails.length > 1">
                <div *ngFor="let delivery of list.packageDetails; let i = index" class="delivery-box">
                  <div class="header-and-parts">
                    <div class="delivery-header">
                      <div>
                        <div class="delivery-i">Delivery {{ i + 1 }}</div>
                        
                      </div>
                      <div>
                        <!-- <div *ngIf="delivery.shipmentStatus === 'Delivered'" class="deliverd-status-and-icon" >
                          <div class="delivered-status">Delivered</div>
                          <mat-icon class="check-circle-mat-icon delivered-status mat-icon" style="padding-top: 3px !important;">check_circle</mat-icon>
                        </div> -->
                        <div class="status requested"  *ngIf="delivery.shipmentStatus === 'packed'">📦 Packed</div>
                      <div class="status quote-received"  *ngIf="delivery.shipmentStatus === 'On The Way'">🚚 On The Way</div>
                      <div class="status quote-approved"  *ngIf="delivery.shipmentStatus === 'confirmed'">✅ Confirmed</div>
                      <div class="status order-created"  *ngIf="delivery.shipmentStatus === 'delivered'">📍 Delivered</div>
                      <div class="status ordered-created"  *ngIf="delivery.shipmentStatus === 'created'">🆕 Created</div>
                    
                      </div>                      
                    </div>
                    
                        <div class="delivery-content">
                          <div  class="request-ids" style="width: 85%">
                            <div class="header-row-newest">
                              <div class="order-item-new">
                              <div class="items-rqstd-cls">Items Ordered</div>
                                <span *ngFor="let item of delivery.items; let idx = index" class="item-name">
                                  <span *ngIf="idx != 0">,</span> {{ item.name }}
                                </span>
                              </div>
                            </div>
                          </div>
                          
                        <div class="order-status" *ngIf=" delivery.shipmentStatus === 'delivered'">
                          <div class="time-badge">
                            <div class="delived-in-time">⏰ {{ delivery.time }}</div>
                          </div>
                        </div>
                        </div>
                  </div>
                </div>
                <!-- ✅ Show Not Packed Items for each order -->
                 <div *ngIf="list.notPackedItems.length > 0">
                   <div  class="delivery-box">
                  <div class="header-and-parts">
                    <div class="delivery-header">
                      <div>
                        <div style="font-size: 15px;">To Be Delivered</div>
                        
                      </div>
                      <div>
                        <!-- <div *ngIf="delivery.shipmentStatus === 'Delivered'" class="deliverd-status-and-icon" >
                          <div class="delivered-status">Delivered</div>
                          <mat-icon class="check-circle-mat-icon delivered-status mat-icon" style="padding-top: 3px !important;">check_circle</mat-icon>
                        </div> -->
                        <div class="status quote-approved" >
                         ✅ Confirmed 
                         <!-- <mat-icon  class="check-circle-mat-icon confirmed-status">thumb_up</mat-icon> -->
                        </div>
                      </div>                      
                    </div>
                    
                        <div class="delivery-content">
                          <div  class="request-ids" style="width: 85%">
                            <div class="header-row-newest">
                              <div class="order-item-new">
                               <div class="items-rqstd-cls">Items Ordered</div>
                                <span *ngFor="let item of list.notPackedItems; let idx = index" class="item-name">
                                  <span *ngIf="idx != 0">,</span> {{ item.partName }}
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                  </div>
                </div>
                </div>

              </div>
              <div *ngIf="list.packageDetails.length == 1 && list.notPackedItems.length > 0">
                <div *ngFor="let delivery of list.packageDetails; let i = index" class="delivery-box">
                  <div class="header-and-parts">
                    <div class="delivery-header">
                      <div>
                        <div style="font-size: 15px;">Delivery {{ i + 1 }}</div>
                        
                      </div>
                      <div>
                        <!-- <div *ngIf="delivery.shipmentStatus === 'Delivered'" class="deliverd-status-and-icon" >
                          <div class="delivered-status">Delivered</div>
                          <mat-icon class="check-circle-mat-icon delivered-status mat-icon" style="padding-top: 3px !important;">check_circle</mat-icon>
                        </div> -->
                       <div class="status requested"  *ngIf="delivery.shipmentStatus === 'packed'">📦 Packed</div>
                      <div class="status quote-received"  *ngIf="delivery.shipmentStatus === 'On The Way'">🚚 On The Way</div>
                      <div class="status quote-approved"  *ngIf="delivery.shipmentStatus === 'confirmed'">✅ Confirmed</div>
                      <div class="status order-created"  *ngIf="delivery.shipmentStatus === 'delivered'">📍 Delivered</div>
                      <div class="status ordered-created"  *ngIf="delivery.shipmentStatus === 'created'">🆕 Created</div>
                    
                      </div>                      
                    </div>
                    
                        <div class="delivery-content">
                          <div  class="request-ids" style="width: 85%">
                            <div class="header-row-newest">
                              <div class="order-item-new">
                                <span *ngFor="let item of delivery.items; let idx = index">
                                  <span *ngIf="idx != 0">,</span> {{ item.name }}
                                </span>
                              </div>
                            </div>
                          </div>
                          
                        <div class="order-status" *ngIf=" delivery.shipmentStatus === 'delivered'">
                          <div class="time-badge">
                            <div class="delived-in-time">⏰ {{ delivery.time }}</div>
                          </div>
                        </div>
                        </div>
                  </div>
                </div>
                <!-- ✅ Show Not Packed Items for each order -->
                 <div *ngIf="list.notPackedItems.length > 0">
                   <div  class="delivery-box">
                  <div class="header-and-parts">
                    <div class="delivery-header">
                      <div>
                        <div style="font-size: 15px;">To Be Delivered</div>
                        
                      </div>
                      <div>
                        <!-- <div *ngIf="delivery.shipmentStatus === 'Delivered'" class="deliverd-status-and-icon" >
                          <div class="delivered-status">Delivered</div>
                          <mat-icon class="check-circle-mat-icon delivered-status mat-icon" style="padding-top: 3px !important;">check_circle</mat-icon>
                        </div> -->
                        <div class="status quote-approved" >
                         ✅ Confirmed 
                            <!-- <mat-icon  class="check-circle-mat-icon confirmed-status">thumb_up</mat-icon> -->
                        </div>
                      </div>                      
                    </div>
                    
                        <div class="delivery-content">
                          <div  class="request-ids" style="width: 85%">
                            <div class="header-row-newest">
                              <div class="order-item-new">
                                <span *ngFor="let item of list.notPackedItems; let idx = index">
                                  <span *ngIf="idx != 0">,</span> {{ item.partName }}
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                  </div>
                </div>
                </div>

              </div>
              <div class="header-row2">
                <div class="order-date">
                  <span>Placed on: {{list.createdAt | date: 'dd MMM yyyy'}}, {{list.createdAt | date: 'hh:mm a'}}</span>
                  <button (click)="loadorderdetails(list.orderKey)" class="Viewbtn">
                    <mat-icon style="color: white;">keyboard_arrow_right</mat-icon>
                    <span class="view">View Details</span>
                  </button>
                </div>
              </div>
              
            </div>
          </div>
        
    

  <!-- <infinite-scroll
  [infiniteScrollDistance]="scrollDistance"
  [infiniteScrollUpDistance]="scrollUpDistance"
  [infiniteScrollDelay]="scrollDelay"
  [infiniteScrollImmediateCheck]="true"
  (scrolled)="onScroll()">
</infinite-scroll> -->
<mat-paginator
    (page)="handlePageEvent($event)"
    [length]="length"
    [pageSize]="pageSize"
    [showFirstLastButtons]="true"
    [pageSizeOptions]="pageSizeOptions"
    [pageIndex]="pageIndex"
    aria-label="Select page">
</mat-paginator>
</div>
</div>
</div>
</div>
</div>
<div #dynamicContainer></div>
<div *ngIf="loading">
<div #dynamicContainers></div>
</div>
